export const createTransactionRoute = '/transaction/create';
export const updateTransactionRoute = '/transaction/update';
export const getTransactionsRoute = '/transaction/get';
export const deleteTransactionRoute = '/transaction/delete';
